import { IOrder, IStoreForm } from "@core/types/storeForm";
import { create, StateCreator } from "zustand";
import { persist, StorageValue } from "zustand/middleware";

const store: StateCreator<IStoreForm> = (set) => ({
  idAddress: 0,
  tableNumber: "",
  currentOrders: [],
  allOrders: [],
  oldOrders: [],

  animationBtnBill: false,
  setAnimationBill: (value) => set(() => ({ animationBtnBill: value })),
  setIdAddress: (idAddress) => set(() => ({ idAddress })),

  fillAllOrders: () =>
    set(({ currentOrders, oldOrders }) => ({
      allOrders: [...(currentOrders ?? []), ...(oldOrders ?? [])],
    })),
  replaceOldOrders: (orders: IOrder[]) => set(() => ({ oldOrders: orders })),
  replaceAllOrders: (orders: IOrder[]) => set(() => ({ allOrders: orders })),
  cleanCurrentOrders: () => set(() => ({ currentOrders: [] })),
  addOrder: (order: IOrder) =>
    set(({ currentOrders }) => ({
      currentOrders: [...(currentOrders ?? []), order],
    })),
  updateDescriptionOrder: (idOrder, description) =>
    set(({ currentOrders }) => ({
      currentOrders: currentOrders?.map((order) =>
        order.idOrder === idOrder ? { ...order, description } : order,
      ),
    })),
  updateOrderById: (idOrder: string, quantity: number) =>
    set(({ currentOrders }) => ({
      currentOrders: currentOrders?.map((order) =>
        order.idOrder === idOrder ? { ...order, quantity } : order,
      ),
    })),

  updateOrderByFood: (newOrder: IOrder) =>
    set(({ currentOrders }) => ({
      currentOrders: currentOrders?.map((order) =>
        order.food?.idFood === newOrder.food?.idFood
          ? { ...order, quantity: newOrder.quantity }
          : order,
      ),
    })),
  updateOrderByFoodVariant: (newOrder: IOrder) =>
    set(({ currentOrders }) => ({
      currentOrders: currentOrders?.map((order) =>
        order.foodVariant?.idFoodVariant === newOrder.foodVariant?.idFoodVariant
          ? { ...order, quantity: newOrder.quantity }
          : order,
      ),
    })),
  updateOrderWithFoodOptions: (newOrder: IOrder) =>
    set(({ currentOrders }) => {
      return {
        currentOrders: currentOrders?.map((order) =>
          order.foodVariant?.idFoodVariant ===
          newOrder.foodVariant?.idFoodVariant
            ? { ...order, quantity: newOrder.quantity }
            : order,
        ),
      };
    }),
  removeOrderById: (idOrder: string) => {
    set(({ currentOrders }) => ({
      currentOrders: currentOrders?.filter(
        (order) => order.idOrder !== idOrder,
      ),
    }));
  },
  removeOrderByFood: (idFood: number) => {
    set(({ currentOrders }) => ({
      currentOrders: currentOrders?.filter(
        (order) => order.food?.idFood !== idFood,
      ),
    }));
  },
  removeOrderByFoodVariant: (idFoodVariant: number) => {
    set(({ currentOrders }) => ({
      currentOrders: currentOrders?.filter(
        (order) => order.foodVariant?.idFoodVariant !== idFoodVariant,
      ),
    }));
  },
  removeOrderWithFoodOptions: (idFoodVariant: number) => {
    set(({ currentOrders }) => ({
      currentOrders: currentOrders?.filter(
        (order) => order.foodVariant?.idFoodVariant !== idFoodVariant,
      ),
    }));
  },
  //Modality
  setTableNumber: (tableNumber) => set(() => ({ tableNumber })),
  setPickupDate: (pickupDate) => set(() => ({ pickupDate })),
  setDeliveryAddress: (deliveryAddress) => set(() => ({ deliveryAddress })),

  setPaymentMethod: (paymentMethod) => set(() => ({ paymentMethod })),
});

export const useStoreForm = create<IStoreForm, [["zustand/persist", unknown]]>(
  persist(store, {
    name: "Alegriia",
    storage: {
      getItem: (name) => {
        const str = localStorage.getItem(name);
        if (!str) return null;
        const data: { idAddress: number } = JSON.parse(str);
        return { state: { ...data } };
      },
      setItem: (name, newValue: StorageValue<IStoreForm>) => {
        const str = JSON.stringify(newValue.state);
        localStorage.setItem(name, str);
      },
      removeItem: (name) => localStorage.removeItem(name),
    },
  }),
);
